import styled from 'styled-components';
import { Input } from 'antd';

const InputEmail = styled(Input)`
  &&& {
    border: none;
    border-bottom: 1px solid #e5e5e5;
    &:focus {
      box-shadow: none;
      border: none;
      border-bottom: 1px solid #9f9f9f;
    }
    &:hover {
      box-shadow: none;
      border: none;
      border-bottom: 1px solid #9f9f9f;
    }
    &:active {
      border-right-width: 0px !important;
      box-shadow: none;
      border: none;
      border-bottom: 1px solid #9f9f9f;
    }
    svg {
      path {
        width: 30px;
      }
    }
    .anticon {
      font-size: 22px;
    }
  }
`;

export default InputEmail;
